export default __webpack_public_path__ + "static/media/bookmark.4d30d234.svg";